module.exports = __webpack_public_path__ + "media/images/perceive-agent-3d0902fde1e5c20109220b2091095e62.png";